import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import AutoLogin from "@/components/AutoLogin";
import ProjectChoose from "@/components/ProjectChoose";
import ProjectChoose_order from "@/components/ProjectChoose_order";
import main from "@//components/main";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 实时监测
import realTimeData from "@//components/monitor/real-time-data-normal.vue";
import realTimeData_order from "@//components/monitor/real-time-data-normal_order.vue";
import realTimeData2d from "@//components/monitor/real-time-data-2d.vue";

// 数据管理
import dindex from "@//components/dataManage/index";
import dataChart from "@//components/dataManage/history-data-chart.vue";
import warnRecord from "@//components/dataManage/warn-record";
import inspectionRecords from "@//components/dataManage/inspection-records.vue";
import checkSet from "@//components/dataManage/checkSet.vue";
import relationPoint from "@//components/dataManage/relationPoint.vue";
import dataDownload from "@//components/dataManage/dataDownload.vue";
import videoRecords from "@//components/dataManage/videoRecords.vue";

// 环境评价
import eindex from "@//components/evaluation/index";
import EvaluationFirst from "@//components/evaluation/EvaluationFirst";
import EvaluationSecond from "@//components/evaluation/EvaluationSecond";
import EvaluationThird from "@//components/evaluation/EvaluationThird";
import EvaluationFourth from "@//components/evaluation/EvaluationFourth";

// 报表管理
import rindex from "@//components/reportManage/index";
import dayreport from "@//components/reportManage/DayReport";
import dayReportNew from "@//components/reportManage/DayReportNew";
import WeekReport from "@//components/reportManage/WeekReport";
import MonthReport from "@//components/reportManage/MonthReport";
import MonthReportNew from "@//components/reportManage/MonthReportNew";
import YearReport from "@//components/reportManage/YearReport";

// 工程信息
import pindex from "@//components/project/index";
import ProjectInfo from "@//components/project/ProjectInfo";
import childprojects from "@//components/project/childprojects";
import measures from "@//components/project/measures";
import CedianGroup from "@//components/project/CedianGroup/CedianGroup";
import AlarmInfor from "@//components/project/alarmInfor";
import DataManagement from "@//components/project/DataManagement";
import smsAlarm from "@//components/project/smsAlarm";

// 系统设置
import sindex from "@//components/systemSetting/index";
import interfaceSetting from "@//components/systemSetting/interface-setting";
import SystemLogs from "@//components/systemSetting/SystemLogs";
import MailboxPush from "@//components/systemSetting/MailboxPush";
import UserManage from "@//components/systemSetting/userManage";

Vue.use(Router);

// 解决vue项目路由出现message: "Navigating to current location (XXX) is not allowed"的问题
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/AutoLogin",
      name: "AutoLogin",
      component: AutoLogin
    },
    {
      path: "/ProjectChoose",
      name: "ProjectChoose",
      component: ProjectChoose
    },
    {
      path: "/ProjectChoose_order",
      name: "ProjectChoose_order",
      component: ProjectChoose_order
    },
    {
      path: "/main",
      name: "main",
      children: [
        {
          path: "realTimeData",
          name: "realTimeData",
          component: realTimeData
        },
        {
          path: "realTimeData_order",
          name: "realTimeData_order",
          component: realTimeData_order
        },
        {
          path: "realTimeData2d",
          name: "realTimeData2d",
          component: realTimeData2d
        },
        {
          path: "/dataManage",
          name: "dataManage",
          component: dindex,
          children: [
            {
              path: "dataChart",
              name: "dataChart",
              component: dataChart
            },
            {
              path: "warnRecord",
              name: "warnRecord",
              component: warnRecord
            },
            {
              path: "inspectionRecords",
              name: "inspectionRecords",
              component: inspectionRecords
            },
            {
              path: "checkSet",
              name: "checkSet",
              component: checkSet
            },
            {
              path: "relationPoint",
              name: "relationPoint",
              component: relationPoint
            },
            {
              path: "dataDownload",
              name: "dataDownload",
              component: dataDownload
            },
            {
              path: "videoRecords",
              name: "videoRecords",
              component: videoRecords
            }
          ]
        },
        {
          path: "/evaluation",
          name: "evaluation",
          component: eindex,
          redirect: "/EvaluationFirst",
          children: [
            {
              path: "/EvaluationFirst",
              name: "EvaluationFirst",
              component: EvaluationFirst
            },
            {
              path: "/EvaluationSecond",
              name: "EvaluationSecond",
              component: EvaluationSecond
            },
            {
              path: "/EvaluationThird",
              name: "EvaluationThird",
              component: EvaluationThird
            },
            {
              path: "/EvaluationFourth",
              name: "EvaluationFourth",
              component: EvaluationFourth
            }
          ]
        },
        {
          path: "/project",
          name: "project",
          component: pindex,
          children: [
            {
              path: "/ProjectInfo",
              name: "ProjectInfo",
              component: ProjectInfo
            },
            {
              path: "childprojects",
              name: "childprojects",
              component: childprojects
            },
            {
              path: "measures",
              name: "measures",
              component: measures
            },
            {
              path: "/CedianGroup",
              name: "CedianGroup",
              component: CedianGroup
            },
            {
              path: "/AlarmInfor",
              name: "AlarmInfor",
              component: AlarmInfor
            },
            {
              path: "/DataManagement",
              name: "DataManagement",
              component: DataManagement
            },
            {
              path: "/smsAlarm",
              name: "smsAlarm",
              component: smsAlarm
            }
          ]
        },
        {
          path: "/report",
          name: "report",
          component: rindex,
          children: [
            {
              path: "dayreport",
              name: "dayreport",
              component: dayreport
            },
            {
              path: "dayReportNew",
              name: "dayReportNew",
              component: dayReportNew
            },
            {
              path: "WeekReport",
              name: "WeekReport",
              component: WeekReport
            },
            {
              path: "MonthReport",
              name: "MonthReport",
              component: MonthReport
            },
            {
              path: "MonthReportNew",
              name: "MonthReportNew",
              component: MonthReportNew
            },
            {
              path: "YearReport",
              name: "YearReport",
              component: YearReport
            }
          ]
        },
        {
          path: "setting",
          name: "setting",
          component: sindex,
          children: [
            {
              path: "interfaceSetting",
              name: "interfaceSetting",
              component: interfaceSetting
            },
            {
              path: "systemLogs",
              name: "systemLogs",
              component: SystemLogs
            },
            {
              path: "mailboxPush",
              name: "mailboxPush",
              component: MailboxPush
            },
            {
              path: "userManage",
              name: "userManage",
              component: UserManage
            }
          ]
        }
      ],
      component: main
    }
  ]
});

// 导航守卫
router.beforeEach((to, from, next) => {
  let hasToken = window.localStorage.getItem("token"); //获取浏览器缓存的用户信息
  let projectCode = window.localStorage.getItem("projectCode");

  if (hasToken || to.path == "/AutoLogin") {
    //如果有就直接到首页
    // 如果 projectCode == ZTGHY，重定向到对应的 _order 页面
    if (projectCode === "ZTGHY") {
      if (to.name === "ProjectChoose" || to.path === "/ProjectChoose") {
        next({ name: "ProjectChoose_order" });
        return;
      }
      if (to.name === "realTimeData" || to.path === "/main/realTimeData") {
        next({ name: "realTimeData_order" });
        return;
      }
    }
    next();
  } else {
    if (to.path === "/") {
      //如果是登录页面路径，就直接next()
      next();
    } else {
      //不然就跳转到登录；
      next("/");
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js